// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RSWb","title":"styles_title__2PSAg"};